import { render, staticRenderFns } from "./ListSubtipoPage.vue?vue&type=template&id=0d797c36"
import script from "./ListSubtipoPage.vue?vue&type=script&lang=js"
export * from "./ListSubtipoPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports